import React, { useEffect } from 'react';
import getConfig from 'next/config';
import GuideCard from './components/guide-card/guide-card';
import * as guideCardStyles from './components/guide-card/guide-card-2026.style';
import * as styles from './ultimate-guide-2026.style';
import {
  FAA_LANDING_PAGE_MODULE,
  trackContentCarouselCta,
  trackContentCarouselItem,
  trackViewMore,
} from '../../../../tracking/landing-page';
import type { FaaLandingPageModule } from '../../../../tracking/landing-page';
import { getPublicUrl } from '../../../../utils';

const list = [
  {
    title: 'Selling',
    subTitle: 'How and when to sell your home',
    imageURL: '/ultimate-guide/selling.jpeg',
    articleLink: '/advice/selling',
  },
  {
    title: 'Buying',
    subTitle: 'Buying Property: Tips, Guides & Advice',
    imageURL: '/ultimate-guide/selling-choose-agent.jpeg',
    articleLink: '/advice/buying',
  },
  {
    title: 'Investing',
    subTitle: 'The ultimate guide to property investing',
    imageURL: '/ultimate-guide/investing.jpeg',
    articleLink: '/advice/investing',
  },
  {
    title: 'Renting',
    subTitle: 'Renting A Home: Renting Tips, Guides & Advice',
    imageURL: '/ultimate-guide/renting.jpeg',
    articleLink: '/advice/renting',
  },
];

const guideInfo = {
  viewAll: 'View all',
  link: '/advice/',
  carouselName: 'Guides',
  carouselTitle: 'Advice, guides and tips',
};

const carouselTitle = 'Advice, guides and tips';

interface UltimateGuide2026Props {
  onModuleRendered?: (module: FaaLandingPageModule) => void;
  modules?: FaaLandingPageModule[];
}

const UltimateGuide2026 = ({
  onModuleRendered,
  modules,
}: UltimateGuide2026Props): JSX.Element => {
  const { publicRuntimeConfig } = getConfig();
  const baseUrlWithProtocol = publicRuntimeConfig?.BASE_URL || '';

  const handleViewAllClick = (): void => {
    trackViewMore();
    trackContentCarouselCta({
      carouselName: guideInfo.carouselName,
      carouselTitle: guideInfo.carouselTitle,
      interactionCTA: guideInfo.viewAll,
      modules,
    });
  };

  useEffect(() => {
    onModuleRendered?.(FAA_LANDING_PAGE_MODULE.CONTENT_CAROUSEL_GUIDES);
  }, [onModuleRendered]);

  return (
    <div css={styles.ultimateGuides}>
      <div css={styles.titleWrapper}>
        <h3 css={styles.title}>{carouselTitle}</h3>
        <a
          target="_blank"
          rel="noreferrer"
          css={styles.viewAll}
          href={`${baseUrlWithProtocol}${guideInfo.link}`}
          onClick={handleViewAllClick}
        >
          {guideInfo.viewAll}
        </a>
      </div>
      <ul css={styles.wrapper}>
        {list.map((item, index) => (
          <li key={item.articleLink}>
            <GuideCard
              title={item.title}
              subTitle={item.subTitle}
              imageURL={getPublicUrl(item.imageURL)}
              articleLink={item.articleLink}
              onArticleClick={() =>
                trackContentCarouselItem({
                  carouselName: FAA_LANDING_PAGE_MODULE.CONTENT_CAROUSEL_GUIDES,
                  carouselTitle,
                  articleId: item.articleLink,
                  articleTags: item.title,
                  articleTitle: item.subTitle,
                  position: index + 1,
                  modules,
                })
              }
              styles={guideCardStyles}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UltimateGuide2026;
